
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import ValidationResult from '@infrastructure/validation-result';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'error-summary',
    template: `
    @for (item of errors.errors; track item) {
      <div class="text-danger">{{item.error | translate}}</div>
    }
    `,
    styleUrls: ['./error-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class ErrorSummaryComponent {
	@Input() errors: ValidationResult;
}
